/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { validateGroupQuestion } from "./validate-group-question";
import { validateTitleAndKey, validateTitle } from "./validate-question-title-key";
import { validateContent } from "./validate-question-content";
import { validateGridQuestion } from "./validate-grid-question";

export const validationFuncByType = {
    "question.paragraph": (question) => {
        return validateContent(question);
    },
    "question.heading": (question) => {
        return validateTitle(question);
    },
    "question.richtext": (question) => {
        return validateContent(question);
    },
    "question.infoBox": () => {
        return [];
    },
    "question.grid": (question) => {
        return [...validateTitleAndKey(question), ...validateGridQuestion(question)];
    },
    "question.group": (question) => {
        return [...validateTitleAndKey(question), ...validateGroupQuestion(question)];
    },
};

// export const getValidationFunc = (question) => {
//     const type = question?.type;
//     const func = validationFuncByType[type];
//     // eslint-disable-next-line no-constant-condition
//     if (typeof func !== "function" ) {
//         return validateTitleAndKey(question);
//     }
//     // throw Error(`Question validator no found for type: $${type}. ${JSON.stringify(question)}`);
//     return func;
// };
